/* src/app/core/pages/login-form/login-form.component.scss */
.main-container {
  transition: ease-in-out 0.3s;
}
.main-container ::ng-deep .p-inputtext {
  font-size: 0.8rem;
  padding: 0.6rem;
  width: 100%;
}
.main-container ::ng-deep .p-button {
  font-size: 0.85rem;
  font-weight: 500;
}
.logged-in {
  transform: translateX(100%);
}
.login-form {
  display: none;
}
.sso-button {
  padding: 0.65rem;
}
/*# sourceMappingURL=login-form.component.css.map */
